
let initialState = {
    activeParent: 'Uživatel', elements: [

        { 'text': 'To Do - úkoly', 'link': '/todolist', 'iconClassName': 'fas fa-tasks', 'isActive': true },
        { 'text': 'Významné dny', 'link': '/importantdates', 'iconClassName': 'far fa-calendar-check', 'isActive': false },
        { 'text': 'Kalendář', 'link': '#', 'iconClassName': 'far fa-calendar-alt', 'isActive': false },
        { 'text': 'Dlužníček', 'link': '#', 'iconClassName': 'far fa-money-bill-alt', 'isActive': false },
        { 'text': 'Lifestyle', 'link': '/lifestyle', 'iconClassName': 'fas fa-walking', 'isActive': false },
        { 'text': 'Nákupníček', 'link': '/shopping', 'iconClassName': 'fas fa-shopping-cart', 'isActive': false }
    ]
};

export const sideNavigationReducer = (state: any = initialState, action: any) => {

    switch (action.type) {
        case 'USER_NAVIGATION':

            let userNavigationElements = {
                activeParent: 'Uživatel', elements: [

                    { 'text': 'To Do - úkoly', 'link': '/todolist', 'iconClassName': 'fas fa-tasks', 'isActive': true },
                    { 'text': 'Významné dny', 'link': '/importantdates', 'iconClassName': 'far fa-calendar-check', 'isActive': false },
                    { 'text': 'Kalendář', 'link': '#', 'iconClassName': 'far fa-calendar-alt', 'isActive': false },
                    { 'text': 'Dlužníček', 'link': '#', 'iconClassName': 'far fa-money-bill-alt', 'isActive': false },
                    { 'text': 'Lifestyle', 'link': '/lifestyle', 'iconClassName': 'fas fa-walking', 'isActive': false },
                    { 'text': 'Nákupníček', 'link': '/shopping', 'iconClassName': 'fas fa-shopping-cart', 'isActive': false }
                ]
            };

            return userNavigationElements;

        case 'HOUSE_NAVIGATION':

            let houseNavigationElements = {
                activeParent: 'Domácnost', elements: [

                    { 'text': 'Údržba', 'link': '/todolist', 'iconClassName': 'fas fa-cogs', 'isActive': true },
                    { 'text': 'Dokumenty', 'link': '#', 'iconClassName': 'far fa-folder-open', 'isActive': false },
                    { 'text': 'Smlouvy', 'link': '#', 'iconClassName': 'far fa-folder-open', 'isActive': false },
                    { 'text': 'Záruční doby', 'link': '#', 'iconClassName': 'fas fa-business-time', 'isActive': false }
                ]
            };

            return houseNavigationElements;

        case 'FINANCE_NAVIGATION':
            let financeNavigationElements = {
                activeParent: 'Finance', elements: [

                    { 'text': 'Výdaje', 'link': '/expenses', 'iconClassName': 'fas fa-money-check', 'isActive': true },
                    { 'text': 'Faktury', 'link': '/invoices', 'iconClassName': 'fas fa-file-invoice-dollar', 'isActive': false },
                    { 'text': 'Účtenky', 'link': '/bills', 'iconClassName': 'far fa-money-bill-alt', 'isActive': false },
                    { 'text': 'Služby', 'link': '#', 'iconClassName': 'fas fa-project-diagram', 'isActive': false },
                    { 'text': 'Revize', 'link': '#', 'iconClassName': 'fas fa-tools', 'isActive': false },
                    { 'text': 'Vyúčtování', 'link': '#', 'iconClassName': 'fas fa-search-dollar', 'isActive': false },
                ]
            };

            return financeNavigationElements;

        case 'GARAGE_NAVIGATION':
            let carNavigationElements = {
                activeParent: 'Garáž', elements: [

                    { 'text': 'Servis', 'link': '/carservice', 'iconClassName': 'fas fa-tools', 'isActive': true },
                    ]
            };

            return carNavigationElements;
    }

    return state;
}